module.exports = __webpack_public_path__ + "static/img/s2_middle_bg.e5fd226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s2_middle_bg.png
// module id = tJyn
// module chunks = 0